// Decode a JWT payload safely (handles URL-safe base64 + padding)
function decodeJwtPayload(token) {
  const payloadPart = (token || '').split('.')[1] || '';
  const b64 = payloadPart.replace(/-/g, '+').replace(/_/g, '/')
    + '==='.slice((payloadPart.length + 3) % 4); // pad
  try {
    const json = typeof atob === 'function'
      ? atob(b64)
      : Buffer.from(b64, 'base64').toString('utf8');
    return JSON.parse(json || '{}');
  } catch {
    return {};
  }
}

// Get a fresh ID token from auth plugin
export function getIdToken(auth) {
  return new Promise((resolve) => {
    if (!auth || typeof auth.getIdToken !== 'function') return resolve(null);
    auth.getIdToken((err, token) => {
      if (err || !token) return resolve(null);
      resolve(token);
    });
  });
}

/**
 * ensureAdmin(auth, allowedGroups?)
 * - auth: something that implements auth.getIdToken(cb)
 * - allowedGroups: string or array of strings (Cognito group names/ids)
 *
 * Returns: Promise<boolean>
 */
export async function ensureAdmin(auth, allowedGroups = ['105877']) {
  const token = await getIdToken(auth);
  if (!token) return false;

  const payload = decodeJwtPayload(token);
  const groups = Array.isArray(payload['cognito:groups'])
    ? payload['cognito:groups']
    : [];

  const allowed = Array.isArray(allowedGroups)
    ? allowedGroups
    : [allowedGroups];

  return groups.some(g => allowed.includes(g));
}

// Export a raw helper if you ever need to check an arbitrary token
export function isAdminFromToken(token, allowedGroups = ['105877']) {
  const payload = decodeJwtPayload(token);
  const groups = Array.isArray(payload['cognito:groups'])
    ? payload['cognito:groups']
    : [];
  const allowed = Array.isArray(allowedGroups) ? allowedGroups : [allowedGroups];
  return groups.some(g => allowed.includes(g));
}
